import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/course/type"

const courseType = {
  courseTypePageList(pageSize, limit, keyWord) {
    return axios.get(pre + `/courseTypePageList`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          keyWord: keyWord
        }
    });
  },
  courseTypeInfo(id) {
    return axios.get(pre + `/courseTypeInfo`, {params: {id: id}});
  },
  courseTypeSave(params) {
    return axios.post(pre + `/courseTypeSave`, qs.stringify(params));
  },
  courseTypeDelete(id) {
    return axios.delete(pre + `/courseTypeDelete`, {params: {id: id}});
  },
}
export default courseType;



// WEBPACK FOOTER //
// ./src/api/course/courseType.js